import { RouterActionTypes } from '../actions/router.action.types';
import { DefaultRouteState } from '../common/models/route.state';
export var CurrentRouteReducer = function (state, action) {
    if (state === void 0) { state = DefaultRouteState; }
    if (action.type !== RouterActionTypes.SYNC_ROUTE)
        return state.CurrentRoute;
    return {
        Url: window.location ? window.location.hash : null,
        State: UpdateStateDescriptions(state, action.payload.$current, action.payload.params)
    };
};
var UpdateStateDescriptions = function (state, currentState, currentParams) {
    var states = [];
    currentState.path.forEach(function (statePath) {
        var currentStateConfig = GetStateConfigurationForCurrentPath(state.RouteConfiguration, statePath);
        if (currentStateConfig !== undefined && currentStateConfig !== null) {
            var component = currentStateConfig.component;
            var currentStateDesc = {
                Path: statePath.name,
                StateName: ExtractStateName(statePath),
                Params: currentParams,
                Views: currentStateConfig.views,
                ComponentFramework: currentStateConfig.componentFramework,
                Component: component,
                Data: currentStateConfig.data
            };
            states.push(currentStateDesc);
        }
    });
    return states;
};
var GetStateConfigurationForCurrentPath = function (routeConfigurations, statePath) {
    var uiStatePathName = statePath.name;
    if (uiStatePathName === '')
        return null;
    var partnerName = statePath.data.partnerAppName;
    if (partnerName === undefined || partnerName === null) {
        console.error("ERROR: Partner name has not been added for the current path");
        return null;
    }
    var routeConfiguration = routeConfigurations.find(function (config) { return config.applicationName === partnerName; });
    if (routeConfiguration === undefined || routeConfiguration === null) {
        console.error("ERROR: The route configuration for the current path is not defined");
        return null;
    }
    var currentStateConfig = routeConfiguration.routes.find(function (route) { return route.name === uiStatePathName; });
    return currentStateConfig;
};
var ExtractStateName = function (statePath) {
    var uiStatePathName = statePath.name;
    var uiStateNames = uiStatePathName.split('.');
    var currentStateName = uiStateNames[uiStateNames.length - 1];
    return currentStateName;
};
//# sourceMappingURL=currentRoute.Reducer.js.map